import { useEffect, useState } from 'react';
import { DescriptionBox } from './DescriptionBox';
import { Photo } from './Photo';
import './PhotoInformationContainer.scss';
import { User } from '../UserProfileHeader/types';
import { noop } from 'react-bootstrap-typeahead/types/utils';
import { DocumentType } from '../../constants/DocumentTypeEnum';



type Props = {
    questionData?: any;
    onChange?: (value: any) => void;
    setUploading?: (isUploading: boolean) => void;
    userDetails: User;
    isIntakeQuestionnaire?: boolean;
    onUploadError?: (error: string) => void;
    documentType?: DocumentType | undefined;
};

export const PhotoInformationContainer = ({
    questionData,
    onChange = noop,
    setUploading,
    userDetails,
    isIntakeQuestionnaire,
    onUploadError = noop,
    documentType
}: Props) => {
    const choice = questionData?.choices[0];
    const description = choice?.description;
    const [userFullName, setUserFullName] = useState<string>('');

    useEffect(() => {
        if (userDetails) {
            setUserFullName(userDetails?.full_name);
        }

    }, [userDetails]);

    return (
        <div className={` ${documentType === DocumentType.OFFICE_PIC ? 'office-pic' : 'photo-widget'}`}>
            <Photo
                setUploading={setUploading}
                questionData={questionData}
                onChange={onChange}
                userDetails={userDetails}
                isIntakeQuestionnaire={isIntakeQuestionnaire}
                onUploadError={onUploadError}
                size="l"
                documentType={documentType}
            />
            {(isIntakeQuestionnaire && documentType !== DocumentType.OFFICE_PIC) && (
                <DescriptionBox description={description} userFullName={userFullName} />
            )}
        </div>
    );
};
